import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import {CancellationOrderDialogComponent} from '../../common/cancellation-order-dialog/cancellation-order-dialog.component';
import {CommonService} from '../../services/common.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ConfirmationDialogComponent} from '../../repair-details/confirmation-dialog/confirmation-dialog.component';
import {CreateUnloadingRequestComponent} from '../../common/create-unloading-request/create-unloading-request.component';
import {EventLogsService} from '../../services/event-logs.service';
import {LoadingService} from '../../services/loading.service';
import {MatDialog} from '@angular/material';
import {ToastMessagesService} from '../../services/toast-messages.service';
import {MatTableDataSource} from '@angular/material';
import OrderDetailsConfig from '../../table/configs/loading_order_details.json';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {
  CancellationMaterialDialogComponent
} from "./cancellation-material-dialog/cancellation-material-dialog.component";

@Component({
  templateUrl: './loading-order-details.component.html'
})
export class LoadingOrderDetailsComponent implements OnInit {
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public dataSource: MatTableDataSource<any>;
  public orderDetails: any;
  public orderDetailsConfig: any;
  pendingFlag: number;
  requestsCount: number;
  public basicDetailsConfig: any;
  public showBasicInfo: boolean;
  private user: any;
  private copyOfParentRow: any;
  mainDetails: any;
  details: any = [];
  pageInitialized: boolean;
  order: any;
  public tableContainerWidth: any;
  public canCancelMaterial: boolean;

  public displayedColumns: string[] = ['material_id', 'material_description', 'total_quantity', 'total_quantity_new', 'total_quantity_used', 'quantity_executed',
    'quantity_left', 'date_completed', 'comments', 'evaluation_category_name', 'is_led_name', 'cases_name', 'caps_name', 'bars_name', 'button'];

  constructor(private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              private commonService: CommonService,
              private eventLogsService: EventLogsService,
              private loadingService: LoadingService,
              private matDialog: MatDialog,
              private router: Router,
              private toastMessagesService: ToastMessagesService) {
    this.pageInitialized = false;
    this.showBasicInfo = false;
    this.dataSource = new MatTableDataSource<any>([]);
    this.canCancelMaterial = false;
  }

  public async ngOnInit(): Promise<any> {
    try {
      this.tableContainerWidth = window.innerWidth - 310;
      this.activatedRoute.params.subscribe(async (params) => {
        this.loadingService.show();
        this.mainDetails = await this.commonService.getSimpleList(`loading_command/web/main_details/${params.id}`);
        this.order = await this.commonService.getListWithParameters('loading_command/web/details/new', `${params.id}`) as any[];
        const parentRowRequest = await this.commonService.getListWithParameters(`loading_command/web`, `id=${+params.id}`);
        const parentRow = parentRowRequest[0][0];
        this.copyOfParentRow = parentRow;
        this.orderDetails = {
          loading_order_id: parentRow.command_id,
          order_id: parentRow.id, // row id
          order_id1: parentRow.order_id, // arithmos pareggelias
          order_type_id: parentRow.order_type_id, // apo pou proerxetai p.x aitisi | paraggelia
          desired_delivery_date: parentRow.desired_delivery_date,
          sale_point_id: parentRow.sale_point_id,
          user_id: parentRow.user_id,
          recipient: parentRow.sale_point_name,
          address: parentRow.sale_point_address,
          address2: parentRow.sale_point_address2,
          loading_command_total_canceled_quantity: +this.mainDetails.loading_command_total_canceled_quantity,
          loading_command_total_quantity: +this.mainDetails.loading_command_total_quantity,
          request_type_id: parentRow.request_type_id, // an proerxetai p.x apo simeio pwlisis eparxias | simeio pwlisis idiou diktyou
          status: parentRow.status_id
        };
        this.orderDetails.order_type_id = this.order[0].order_type_id;
        this.orderDetails.request_type_id = this.order[0].request_type_id;
        this.orderDetails.status = this.order[0].status_id;
        this.orderDetails.recipient = this.order[0].sale_point_name ? this.order[0].sale_point_name : this.copyOfParentRow.sale_point_name;
        this.orderDetails.address = this.order[0].sale_point_address ? this.order[0].sale_point_address
          : this.copyOfParentRow.sale_point_address;
        this.orderDetails.reasonId = this.mainDetails.cancel_reason_id;
        this.orderDetails.reasonDescription = this.mainDetails.cancel_reason_description;
        this.orderDetails.requestResultID = this.order[0].request_result_id;
        this.orderDetails.requestResultDescription = this.order[0].request_result_description;

        localStorage.setItem('orderDetails', JSON.stringify(this.orderDetails));

        // const logs = await this.eventLogsService.getRefrigeratorEventLogs('loading_order_details', +params.id);
        this.orderDetailsConfig = OrderDetailsConfig;
        this.orderDetailsConfig.filter = `command_id=${+params.id}`;
        this.dataSource = new MatTableDataSource<any>(this.order);
        this.dataSource.paginator = this.commonService.setPaginatorTexts(this.paginator);
        this.dataSource.sort = this.sort;
        await this.initUser();
        this.pageInitialized = true;
        this.loadingService.hide();
      });


    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  private async initUser() {
    this.user = await this.authService.getUser();
    // const order = await this.commonService.getListWithParameters('loading_command/web/details', `command_id=${this.orderDetails.order_id}`) as any[];


    for (const detail of this.order) {
      this.pendingFlag = detail.number_of_not_pending_unloading_commands;
      this.requestsCount = detail.requests_count;
      const model = {
        material_id: detail.material_id,
        total_quantity: detail.total_quantity,
        total_quantity_new: detail.total_quantity_new,
        total_quantity_used: detail.total_quantity_used
      };
      this.details.push(model);
    }
    this.details = this.order;
    this.initBasicInfo();
  }

  private async initBasicInfo() {
    this.showBasicInfo = true;
    this.basicDetailsConfig = {
      subtitle: [
        {
          title: 'Αριθμός Εντολής',
          value: this.orderDetails.order_id
        }
      ],
      title: 'Πληροφορίες Εντολής Φόρτωσης'
    };

    this.initializeActions();
  }

  private async initializeActions() {
    const actions = [];
    const action = {
      function: () => {
        this.initializeCreateUnloadingOrderDialog(this.orderDetails.order_type_id);
      },
      showAction: this.canShow(),
      title: 'Δημιουργία Εντολής Παραλαβής',
      icon: 'cloud_upload',
      color: '#266ccd'
    };
    // actions.push(action);

    const action2 = {
      function: () => {
        this.initializeConfirmCancellationDialog(this.orderDetails);
      },
      showAction: this.canShowCancelRequest(),
      title: 'Διαγραφή Εντολής Φόρτωσης',
      icon: 'cancel',
      color: 'red'
    };
    // actions.push(action2);

    const action3 = {
      function: () => {
        this.downloadPDF();
      },
      showAction: true,
      title: 'Λήψη PDF',
      icon: 'picture_as_pdf',
      color: '#013e81',
    };
    // actions.push(action3);

    const action4 = {
      function: () => {
        this.cancelFullLoadingOrder();
      },
      showAction: this.canShowCancelButton(),
      title: 'Ακύρωση εντολής φόρτωσης',
      icon: 'block',
      color: '#013e81',
    };
    // actions.push(action4);

    if (this.user.role_id === 1 || this.user.role_id === 10) {
      actions.push(action);
      actions.push(action2);
      actions.push(action3);
      actions.push(action4);
    } else if (this.user.role_alternate_name === 'hqManager') {
      actions.push(action3);
    } else {
      actions.push(action);
      actions.push(action2);
      actions.push(action3);
    }

    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = await this.commonService.showActions(this.user);
    } else {
      this.basicDetailsConfig.showActions = false;
    }
  }

  canShowCancelButton(): boolean {
    let status = false;
    const cancelledMaterials = this.order.filter((item: { is_cancelled: number; }) => item.is_cancelled === 1);
    if (cancelledMaterials.length > 0) {
      return false;
    }
    if (this.orderDetails.status !== 9 && (this.orderDetails.order_type_id === 1 ||
      (this.orderDetails.order_type_id === 2 && this.orderDetails.request_type_id !== 7))) {
      if (this.pendingFlag > 0) {
        status = false;
      } else {
        status = true;
      }
      // status = true;
    }

    return status;
  }

  cancelFullLoadingOrder() {
    const model = {
      id: this.orderDetails.order_id,
      orderId: this.orderDetails.order_id1,
      requestTypeId: this.orderDetails.request_type_id,
      orderTypeId: this.orderDetails.order_type_id, // 1 paraggelia | 2 aitisi
      requestsCount: this.requestsCount
    };
    const dialog = this.matDialog.open(CancellationOrderDialogComponent, {
      width: '650px',
      data: {
        id: model.id,
        title: `Ακύρωση εντολής φόρτωσης με αριθμό ${model.id}`,
        mode: 2,
        orderDetails: model,
      }
    });

    dialog.afterClosed().subscribe(result => {
      if (result) {
        this.toastMessagesService.toastMessages('Η ακύρωση ολοκληρώθηκε με επιτυχία');
      }
    });
  }

  private canShowCancelRequest() {
    if (this.orderDetails.status === 1 && this.orderDetails.request_type_id !== 7) {
      return true;
    }
  }

  async downloadPDF() {
    try {
      await this.commonService.getPDF(`pdf?model=loading_command&id= ${this.orderDetails.order_id}`,
        `Εντολή Φόρτωσης - ${this.orderDetails.order_id}`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  private canShow() {
    if (this.orderDetails.status === 1 || this.orderDetails.status === 2) {
      if (this.orderDetails.order_type_id === 2) {
        return this.orderDetails.request_type_id === 5;
      } else {
        return true;
      }
    } else {
      return false;
    }

  }

  private async initializeConfirmCancellationDialog(details) {
    const cancellationDialog = this.matDialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Είστε σίγουροι ότι θέλετε να διαγράψετε την εντολή φόρτωσης με αριθμό ${details.order_id}?`,
        title: 'Διαγραφή εντολής φόρτωσης'
      }
    });

    cancellationDialog.afterClosed().subscribe(async (response) => {
      if (response) {
        await this.cancelRequest(details);
      }
    });
  }

  private async cancelRequest(details) {
    try {
      await this.commonService.deleteItem(`loading_command/web`, details.order_id);
      this.toastMessagesService.toastMessages('Η διαγραφή ολοκληρώθηκε με επιτυχία');
      await this.router.navigate(['loading_orders']);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  private async initializeCreateUnloadingOrderDialog(type: number) {
    // this.loadingService.show();
    const users = await this.commonService.getListWithParameters('user', 'role_id=2 OR role_id=13 OR role_id=14');
    const details = null;
    // await this.commonService.getListWithParameters('request/web/details', `request_id=${this.requestDetails.requestId}`);
    const roles = await this.commonService.getListWithParameters('role', 'id=6 OR id=13 OR id=14');
    this.loadingService.hide();
    this.matDialog.open(CreateUnloadingRequestComponent, {

      data: {
        orderType: 2,
        roles,
        users,
        details,
        type,
        order_id: this.orderDetails.order_id,
        purchaseDocument: null
      }
    });
  }

  public navigateToRow(row) {
    this.router.navigate([`loading_order_details_info/${row.id}`]);
  }

  public isCancelButtonDisabled(element) {
    if (this.orderDetails.status === 9) {
      this.canCancelMaterial = false;
      return true;
    }
    if (this.order.length === 1 && (this.order[0].quantity_executed === null || this.order[0].quantity_executed === 0)) {
      // σημαίνει ότι έχω μόνο 1 κωδικό και δεν τον έχω φορτώσει καθόλου άρα πρέπει να ακυρώσω όλη την εντολή
      this.canCancelMaterial = false;
      return true;
    } else if (element.is_completed || element.quantity_left === 0) {
      this.canCancelMaterial = false;
      return true;
    } else {
      this.canCancelMaterial = element.is_cancelled !== 1;
      return element.is_cancelled === 1;
    }
  }

  public toolTipForCancelMaterial(row) {
    if (this.canCancelMaterial) {
      return 'Ακύρωση Υπολειπόμενων Ποσοτήτων Κωδικού';
    } else if (!this.canCancelMaterial && row.cancelledMaterialMessage) {
      return row.cancelledMaterialMessage;
    } else {
      return '';
    }
  }

  public cancelRow($event: any, element) {
    $event.stopPropagation();
    const dialog = this.matDialog.open(CancellationMaterialDialogComponent, {
      width: '650px',
      data: {
        row_id: element.id,
        command_id: element.command_id,
        order_type_id: element.order_type_id // 1 paraggelia | 2 aitisi
      }
    });

    dialog.afterClosed().subscribe(async result => {
      if (result) {
        this.toastMessagesService.toastMessages('Η ακύρωση ολοκληρώθηκε με επιτυχία');
        const route = this.router.url;
        this.router.navigated = false;
        this.router.navigate([route]);      }
    });
    return false;
  }
}
